import { render, staticRenderFns } from "./PromocodeForm.vue?vue&type=template&id=72c6a22e"
import script from "./PromocodeForm.vue?vue&type=script&lang=js"
export * from "./PromocodeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports